import React from 'react';

const currentYear = new Date().getFullYear();
const PortalFooter = () => (
  <div className="row-fluid">
    <div id="footer" className="span12">
      2013 - {currentYear} &copy; AristaMD
    </div>
  </div>
);

PortalFooter.displayName = 'PortalFooter';

export default PortalFooter;
